import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const links = {
    pro: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBBHxAji782rD1o9ipnZnm/es-ar?_r=AQABVqBSWHPN4Q1TFNqC4-LTVpLmSeyBScgVK1rMC8aAjRw&cart_link_id=oC8KVQWc&preview_theme_id=151828791463',
    elite: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBBHZcBauqe2E5MXhw79Ag/es-ar?_r=AQABSyFcTDZT3v4KJlGRuWHpd2MV3J4-ZFi6DetN1px-lkg&cart_link_id=qVfpENKk&preview_theme_id=151828791463'
  };
  const ctaText = {
    pro: '→ SÍ, QUIERO EL MEGAPACK NUTRICIONISTA 360º',
    elite: '→ SÍ, QUIERO EL MEGAPACK NUTRICIONISTA 360º + SISTEMA CLÍNICO PRO ELITE™'
  };
  return <section className="relative py-8 px-3 overflow-hidden" data-id="element-198">
      <div className="relative max-w-[680px] mx-auto" data-id="element-199">
        {/* Urgency Counter */}
        <FadeIn className="text-center mb-4" data-id="element-200">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-4 py-2 mb-3" data-id="element-201">
            <Clock size={18} className="text-red-400" data-id="element-202" />
            <span className="text-red-400 font-bold text-sm uppercase tracking-wide" data-id="element-203">
              Oferta termina en
            </span>
            <div className="flex items-center gap-1 font-mono" data-id="element-204">
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-205">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-206">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-207">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-208">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-209">
                {pad(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Selectable Cards */}
        <div className="space-y-3 mb-5" data-id="element-210">
          {/* Card 1: Megapack Nutricionista 360º */}
          <FadeIn delay={0.1} data-id="element-211">
            <div onClick={() => setSelected('pro')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,85,247,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-212">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-white/20 group-hover:border-accent/50'}`} data-id="element-213">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-214" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-215">
                <h3 className={`text-lg md:text-xl font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-216">
                  MEGAPACK NUTRICIONISTA 360º
                </h3>
                <p className="text-white/50 text-sm md:text-base" data-id="element-217">
                  6 Tomos Clínicos + 6 Bonos
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-218">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-219">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-220">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Elite */}
          <FadeIn delay={0.2} data-id="element-221">
            <div onClick={() => setSelected('elite')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,85,247,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-222">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-223">
                <span className="bg-accent text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-224">
                  MÁS ELEGIDO
                </span>
                <span className="text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-accent/80" data-id="element-225">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-white/20'}`} data-id="element-226">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-227" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-228">
                <h3 className={`text-lg md:text-xl font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-229">
                  MEGAPACK NUTRICIONISTA 360º + SISTEMA CLÍNICO PRO ELITE™
                </h3>
                <p className="text-white/60 text-sm md:text-base" data-id="element-230">
                  Incluye el megapack inicial + sistemas específicos
                </p>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-231">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-232">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-233">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-5" data-id="element-234">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-xl py-5 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center text-[16px]" data-id="element-235">
            {ctaText[selected]}
          </motion.a>
          <p className="text-white/50 text-xs mt-3 italic" data-id="element-236">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} data-id="element-237">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface border border-accent/25 rounded-lg py-3 px-4" data-id="element-238">
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-239">
              <Lock size={16} className="text-accent" data-id="element-240" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-241">
              <Zap size={16} className="text-accent" data-id="element-242" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-243">
              <ShieldCheck size={16} className="text-accent" data-id="element-244" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-245">
              <CreditCard size={16} className="text-accent" data-id="element-246" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}